import { GlobalAppCache } from '@/utils/AppCache'
import MaskClient from './base'

class MaskBannerApis {
  getBanner = (id) => {
    const url = 'bannerApi/search/banner/' + id
    return MaskClient.get(url)
  }
  getBanners = (params) => {
    const cacheKey = 'bannerApi/search/banner' + JSON.stringify(params)
    let bannerList = GlobalAppCache.getValue('banner_list', cacheKey)
    let res
    if (bannerList) {
      res = Promise.resolve(bannerList)
    } else {
      res = MaskClient.get(`/bannerApi/search/banner`, { params }).then((res) => {
        GlobalAppCache.addCache('banner_list', cacheKey, res, 300)
        return res
      })
    }
    let isWx = window === 'miniprogram'
    return res.then((res) => {
      if (!isWx) {
        return res
      }
      res.data = res.data.filter((i) => {
        return !i.extra_url
      })
      return res
    })
  }
}

export default new MaskBannerApis()
